import { render, staticRenderFns } from "./AGrados.vue?vue&type=template&id=68a34516"
import script from "./AGrados.vue?vue&type=script&lang=js"
export * from "./AGrados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports